import { useDroppable } from "@dnd-kit/core";
import { rectSortingStrategy, SortableContext } from "@dnd-kit/sortable";
import SortableItem from "./SortableItem";
import React from "react";
import { Grid } from "@deere/fuel-react";

const Droppable = ({ id, questions }) => {
  const { setNodeRef } = useDroppable({ id });

  return (
    <SortableContext id={id} items={questions.map((que) => que.code)} strategy={rectSortingStrategy}>
      <Grid container ref={setNodeRef} mb={4} mt={4} spacing={2} direction="column">
        {questions
          .sort((a, b) => (a.showOrder ?? 0) - (b.showOrder ?? 0))
          .map((que) => (
            <Grid item key={que.code}>
              <SortableItem que={que} />
            </Grid>
          ))}
      </Grid>
    </SortableContext>
  );
};

export default Droppable;
